import React, { useState, useEffect, useRef, useCallback } from "react";
import IleyaSavingsDataService from "../services/IleyaSavingsService";
import { useParams, useNavigate } from 'react-router-dom';
import TransactionTable from "../../components/TransactionTable";

const IleyaSavingsPr = (props) => {
  const [ileyaSavings, setIleyaSavings] = useState([]);
  const ileyaSavingsRef = useRef();
  ileyaSavingsRef.current = ileyaSavings;

  const { owner } = useParams();
  const navigate = useNavigate();

  const retrieveIleyaSavings = useCallback((ownerParam) => {
    const target = ownerParam ?? owner;
    IleyaSavingsDataService.getAll(target)
      .then((response) => setIleyaSavings(response.data || []))
      .catch((e) => { console.error(e); setIleyaSavings([]); });
  }, [owner]);

  useEffect(() => { retrieveIleyaSavings(); }, [retrieveIleyaSavings]);

  const deleteIleyaSavings = useCallback((rowIndex) => {
    const id = ileyaSavingsRef.current[rowIndex].id || ileyaSavingsRef.current[rowIndex]._id;
    IleyaSavingsDataService.remove(id)
      .then(() => {
        const newArr = [...ileyaSavingsRef.current];
        newArr.splice(rowIndex, 1);
        setIleyaSavings(newArr);
      })
      .catch((e) => console.error(e));
  }, []);

  const handleView = useCallback((row) => {
    const id = row.id || row._id;
    if (id) navigate(`/dashboard/ileyasavings/${id}`);
  }, [navigate]);

  const handleEdit = useCallback((row) => {
    const id = row.id || row._id;
    if (id) navigate(`/dashboard/ileyasavings/edit/${id}`);
  }, [navigate]);

  const handleDeleteRow = useCallback((row) => {
    const idx = ileyaSavingsRef.current.findIndex(item => (item.id || item._id) === (row.id || row._id));
    if (idx >= 0) deleteIleyaSavings(idx);
  }, [deleteIleyaSavings]);

  return (
    <div className="list row">
      <div className="col-md-12 list">
        <TransactionTable
          transactions={ileyaSavings}
          onView={handleView}
          onEdit={handleEdit}
          onDelete={handleDeleteRow}
          initialPageSize={10}
          showBack={true}
          onBack={() => navigate(-1)}
        />
      </div>
    </div>
  );
};

export default IleyaSavingsPr;
